export const DATA_GRID_HEADER_CELL_CLASS_NAMES =
  'h-10 bg-bg-light align-middle';

export const DATA_GRID_BODY_CELL_CLASS_NAMES =
  'h-11 bg-bg-primary py-0 align-middle';

export const DATA_GRID_ROW_HEADER_CELL_CLASS_NAMES =
  'h-11 bg-bg-light py-0 align-middle';

export const DATA_GRID_STICKY_HEADER_CLASS_NAMES = 'sticky z-30';
export const DATA_GRID_STICKY_ROW_HEADER_CLASS_NAMES = 'sticky left-0 z-20';
export const DATA_GRID_STICKY_CORNER_CLASS_NAMES = 'sticky left-0 z-40';

export const DATA_GRID_PINNED_SHADOW_CLASS_NAMES = 'shadow-tableBoxShadow';

export const DATA_GRID_COLUMN_SEPARATOR_CLASS_NAMES =
  'border-r-1/2 border-r-border-secondary';

export const DATA_GRID_ROW_SEPARATOR_CLASS_NAMES =
  'border-b-1/2 border-b-border-secondary';

export const DATA_GRID_HEADER_RULE_CLASS_NAMES =
  'border-b-1/2 border-b-border-tertiary';
